// Homepage banners
import banner_one from "../../assets/Carousel Banners/one.jpg";
import banner_two from "../../assets/Carousel Banners/two.jpg";
import banner_three from "../../assets/Carousel Banners/three.jpg";
import banner_four from "../../assets/Carousel Banners/four.jpg";

// Banner images
export const banner_images = {
  banner_four,
  banner_one,
  banner_two,
  banner_three,
};